import {
  MenuItem,
  styled,
} from '@mui/material';
import { spaceCadet } from '../../../../../../utils/colors';
import SelectorAppBarButton from '../../SelectorAppBarButton/styles';

const StyledBox = styled(SelectorAppBarButton)(
  () => ({
    backgroundColor: spaceCadet[300],
    '&:hover': {
      '&:not(.active)': {
        borderRadius: 18,
      },
    },
    '&:has(> .selectButton:hover)': {
      backgroundColor: spaceCadet[300],
    },
  }),
);

export default StyledBox;

export const StyledMenuItem = styled(MenuItem)({
  // padding: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',

  '&.selected': {
    pointerEvents: 'none',

    '& .MuiButton-root': {
      pointerEvents: 'all',
      padding: 4,
      minWidth: 0,

      '& svg': {
        fontSize: 20,
      },
    },
  },

  '& > div': {
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
  },
});
